// lib
import { styled } from '@nykaa/ui-components';

// constants
import { CLASSNAMES } from './constants';
import { MEDIA_BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  .${CLASSNAMES.CONTAINER} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  & .${CLASSNAMES.PRODUCT} {
    width: calc(50% - 1px);
    margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  }
`;

export const Title = styled.div<{ showSeparator: boolean }>`
  padding: ${({ theme }) => `${theme.spacing.spacing100} 0 0`};
  cursor: pointer;
  ${({ theme }) => theme.typography.type201};
  color: ${({ theme }) => theme.colors.textPrimary};
  display: flex;
  justify-content: space-between;

  ${MEDIA_BREAKPOINTS.TILL_TABLET} {
    ${({ theme }) => theme.typography.bodyLarge};

    ${({ showSeparator, theme }) =>
      showSeparator
        ? `padding: ${theme.spacing.spacing80}px ${theme.spacing.spacing40}px 0px;`
        : `padding: ${theme.spacing.spacing120}px ${theme.spacing.spacing40}px ${theme.spacing.spacing80}px;`}
  }
`;
